import { getPageProps, getUrlParam } from '@kibt/krn-utils';
import { Platform } from 'react-native';

export function useQuery<T extends any>(key: string) {
    if (Platform.OS === 'web') {
        const url = new URL(window.location.href);
        const val = url.searchParams.get(key);
        return val as T;
    } else {
        return getUrlParam(key) as T;
    }
}

export function useQuerys<T extends { [key: string]: any }>() {
    if (Platform.OS === 'web') {
        const params = getQuerys();
        return params as T;
    } else {
        return getPageProps() as T;
    }
}

export function getQuerys() {
    return Object.fromEntries(new URLSearchParams(location.search));
}
